export default {
  methods: {
    cubeMapRealtime () {
      //
      // eslint-disable-next-line prettier/prettier
      if (!AFRAME.components['cubemap-realtime']) {
        AFRAME.registerComponent('cubemap-realtime', {
          schema: {
            radius: { type: 'number', default: 100 },
            width: { type: 'number', default: 15 },
            height: { type: 'number', default: 15 }
          },
          init () {
            const ensureMaterialArray = (material) => {
              if (!material) {
                return []
              }
              if (Array.isArray(material)) {
                return material
              }
              if (material.materials) {
                return material.materials
              }
              return [material]
            }
            const applyEnvMap = (mesh, envMap) => {
              if (!mesh) { return }
              mesh.traverse((node) => {
                if (!node.isMesh) {
                  return
                }
                const meshMaterials = ensureMaterialArray(node.material)
                meshMaterials.forEach((material) => {
                  if (material && !('envMap' in material)) { return }
                  material.envMap = envMap
                  material.needsUpdate = true
                })
              })
            }
            const { data } = this
            const scene = this.el.sceneEl
            const camTexture_ = new THREE.Texture()
            const refMat = new THREE.MeshBasicMaterial({
              side: THREE.DoubleSide,
              color: 0xFFFFFF,
              map: camTexture_
            })
            const renderTarget = new THREE.WebGLCubeRenderTarget(256, {
              format: THREE.RGBFormat,
              generateMipmaps: true,
              minFilter: THREE.LinearMipmapLinearFilter,
              encoding: THREE.sRGBEncoding
            })
            // cubemap scene
            const cubeMapScene = new THREE.Scene()
            const cubeCamera = new THREE.CubeCamera(1, 1000, renderTarget)
            const sphere = new THREE.SphereGeometry(
              this.data.radius,
              this.data.width,
              this.data.height
            )
            const sphereMesh = new THREE.Mesh(sphere, refMat)
            sphereMesh.scale.set(-1, 1, 1)
            sphereMesh.rotation.set(Math.PI, -Math.PI / 2, 0)
            cubeMapScene.add(sphereMesh)
            const startListen = () => {
              window.XR8.XrController.configure({ enableLighting: true })
              window.XR8.addCameraPipelineModule({
                name: 'cubemap-process',
                onUpdate: ({ frameStartResult, processCpuResult }) => {
                  cubeCamera.update(scene.renderer, cubeMapScene)
                  let { cameraTexture } = frameStartResult
                  if (processCpuResult.reality) {
                    // use the camera texture that is synced with our XrController
                    cameraTexture = processCpuResult.reality.realityTexture
                  } else if (processCpuResult.facecontroller) {
                    // use the camera texture that is synced with our FaceController
                    cameraTexture =
                      processCpuResult.facecontroller.cameraFeedTexture
                  }
                  // force initialization
                  const texProps = scene.renderer.properties.get(camTexture_)
                  texProps.__webglTexture = cameraTexture
                }
              })
              this.el.addEventListener('model-loaded', () => {
                applyEnvMap(
                  this.el.getObject3D('mesh'),
                  cubeCamera.renderTarget.texture
                )
              })
            }
            window.XR8
              ? startListen()
              : window.addEventListener('xrloaded', startListen)
          },
          /**
           * Called when component is attached and when component data changes.
           * Generally modifies the entity based on the data.
           */
          update (oldData) {
            // this.redraw()
          },
          /**
           * Called when a component is removed (e.g., via removeAttribute).
           * Generally undoes all modifications to the entity.
           */
          remove () {
            if (this.loaded) { this.loaded.remove() }
          },
          /**
           * Called on each scene tick.
           */
          // tick: function (t) { },
          /**
           * Called when entity pauses.
           * Use to stop or remove any dynamic or background behavior such as events.
           */
          pause () {},
          /**
           * Called when entity resumes.
           * Use to continue or add any dynamic or background behavior such as events.
           */
          play () {}
        })
      }
    }
  }
}
